import React from "react";
import { Box, styled, Typography } from "@mui/material";
import { FormatQuote, RocketLaunch, Visibility } from "@mui/icons-material";


const MandVContainer = styled(Box)(({theme}) => ({
  width: "55%",
  height: "100%",
  display: "flex",
  flexDirection: 'row',
  justifyContent: "center",
  alignItems: "center",
  gap: theme.spacing(5),
  
  [theme.breakpoints.down('mdlg')]: {
    flexDirection: 'column',
  }
}));

const MandVCard = styled(Box)(({theme}) => ({
  width: "40%",
  height: "60%",
  bgcolor: "transparent",
  border: "1px solid #ffdd24",
  borderRadius: "10px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-around",
  
  [theme.breakpoints.down('mdlg')]: {
    width: "80%",
  }
}));



function VisionAndMission() {
  return (
    <Box
      sx={{
        width: "100%",
        py: 10,
        // height: "80vh",
        bgcolor: "#242424",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          width: "45%",
          height: "100%",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box sx={{ width: "90%", textAlign: "start" }}>
          <FormatQuote
            sx={{ rotate: "180deg", fontSize: "10rem", color: "#55d6aa" }}
          />
        </Box>
        <Typography
          sx={{
            fontFamily: '"Montserrat", sans-serif',
            color: "antiquewhite",
            width: "80%",
            mb: 2,
          }}
        >
          In a world deluged by irrelevant information, clarity is power.
        </Typography>
        <Box sx={{ width: "90%", textAlign: "end" }}>
          <FormatQuote sx={{ fontSize: "10rem", color: "#55d6aa" }} />
        </Box>
      </Box>

      <MandVContainer>
        <MandVCard>
          <Box>
            <RocketLaunch sx={{ color: "white", fontSize: "5rem" }} />
          </Box>
          <Box>
            <Typography variant="h4" sx={{ color: "#55d6aa" }}>
              Mission
            </Typography>
          </Box>
          <Box sx={{ px: 3, py: 2 }}>
            <Typography
              variant="body2"
              sx={{ color: "antiquewhite", textAlign: "center" }}
            >
              To empower organizations worldwide with accurate, ethical, and
              actionable intelligence that drives confident decision-making,
              accelerates innovation, and fosters sustainable growth. At DataPi,
              we go beyond data we deliver strategic clarity through deep
              research, industry expertise, and unbiased insights tailored to
              each client's unique needs.
            </Typography>
          </Box>
        </MandVCard>

        <MandVCard>
          <Box>
            <Visibility sx={{ color: "white", fontSize: "5rem" }} />
          </Box>
          <Box>
            <Typography variant="h4" sx={{ color: "#55d6aa" }}>
              Vision
            </Typography>
          </Box>
          <Box sx={{ px: 3, py: 2 }}>
            <Typography
              variant="body2"
              sx={{ color: "antiquewhite", textAlign: "center" }}
            >
              To become the most trusted global intelligence partner for
              businesses, governments, and innovators shaping a world where
              every decision is informed by clarity, foresight, and integrity.
              We envision a future where our insights bridge the gap between
              complexity and opportunity, enabling our clients to lead markets,
              adapt to change, and create meaningful impact.
            </Typography>
          </Box>
        </MandVCard>
      </MandVContainer>
    </Box>
  );
}

export default VisionAndMission;
